export const enum LocalStorageKeys {
  FEATURE_TYPES = "featuretypes",
  LAYERS = "layers",
  CURRENCIES = "currencies",
  USER_DETAILS = "userDetails",
  TRANSACTION_CURRENCY = "transactionCurrency",
  AUTO_DETECTED_CURRENCY = "autoDetectedCurrency",
  BOUNDARIES = "boundaries",
  THEME = "theme",
  SATELLITE_MODE = "satelliteMode",
  PENDING_PREMIUM_ORDER = "pendingPremiumOrder",
}
